<template>
  <div class="region-box">
    <el-cascader
      ref="regionCascader"
      :options="options"
      :change-on-select="true"
      :show-all-levels="true"
      filterable
      :props="props"
      :placeholder="placeholder"
      :clearable="true"
      @change="regionChange"
    ></el-cascader>
  </div>
</template>

<script>
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      props: {
        value: 'valobj',
        label: 'nickName'
      }
    };
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  created() {
    // 组件加载时就将省数据加载 如果已加载过就不再加载
    if (this.options.length == 0) {
      this.axiosRequest(null, 0);
    }
  },
  methods: {
    resetData() {
      this.$refs.regionCascader.handleClear();
      this.$emit('back-region', {});
    },
    regionChange(data) {
      // 获取当前点击的节点
      var level = data.length,
        current = {};
      // level为0 表示是清空操作
      if (level != 0) current = data[level - 1];

      // 每次选项值改变 返回数据
      this.$emit('back-region', current);

      if (level != 0 && level != 3) {
        // 第三级不读取数据
        if (!this.arrContains(this.options, current)) {
          this.axiosRequest(current, level);
        }
      }
    },
    async axiosRequest(current, level) {
      var opts = {};
      if (current) opts.regioncode = current.regionCode;
      let res = await axios.post(api.getRegionlist, opts);
      // 遍历返回数据 组合value供返回使用
      res.data &&
        res.data.forEach(function (element) {
          element.valobj = { ...element };
          // 第三级不加children
          if (level != 2) element.children = [];
        }, this);

      if (current) {
        // 更新对应节点数据
        this.updataRegion(this.options, res.data, current);
      } else {
        // 省级别 直接填充数据到state
        this.$store.dispatch('changeRegion', res.data);
      }
    },
    // 判断该区域子节点是否已加载
    arrContains: function (arr, key) {
      var i = arr.length;
      while (i--) {
        if (arr[i].valobj.regionCode == key.regionCode) {
          if (arr[i].children.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          var n = arr[i].children.length;
          while (n--) {
            if (arr[i].children[n].valobj.regionCode == key.regionCode) {
              if (arr[i].children[n].children.length > 0) {
                return true;
              } else {
                return false;
              }
            }
          }
        }
      }
      return false;
    },
    // 将新数据填充到options对应的children 并更新状态机
    updataRegion: function (rdata, data, key) {
      for (var i = 0; i < rdata.length; i++) {
        if (rdata[i].valobj.regionCode == key.regionCode) {
          rdata[i].children = data;
          break;
        } else {
          for (var n = 0; n < rdata[i].children.length; n++) {
            if (rdata[i].children[n].valobj.regionCode == key.regionCode) {
              rdata[i].children[n].children = data;
              break;
            }
          }
        }
      }
      this.$store.dispatch('changeRegion', rdata);
    }
  },
  computed: {
    // 映射state数据
    ...mapState({
      options: state => state.regionData
    })
  }
};
</script>
